import { S3_CONFIG } from './config/config';
import _ from 'lodash';
import { Address } from './interface/interface';

export const isItemInLocalStorage = (key): boolean => {
  const item = localStorage.getItem(key);
  return item !== null;
};

export const getBucketLink = (filename: string): string => {
  return `${S3_CONFIG.cdn_host}/${filename}`;
};

export const descendingComparator = <T>(a: T, b: T, orderBy: string) => {
  const prev = _.get(a,orderBy);
  const next = _.get(b,orderBy);
  if (prev < next) {
    return -1;
  }
  if (prev > next) {
    return 1;
  }
  return 0;
};

export const isValidEmail = (email: string): boolean => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
}

export const formatAddress = (address: any): string => {
  const parts = [
    address.line1,
    address.line2,
    address.city,
    address.state,
    address.postalCode,
    address.country
  ].filter(part => part && part.trim() !== ''); // Filter out empty parts

  return parts.join(', ');
};
